const Repository = require('../base')
const { prepareTranslit } = require('../../helpers')

module.exports = class AutoCompletesRepository extends Repository {
    constructor() {
        super({
            source: 'elastic',
            path: 'autocompletes'
        })
    }

    search(value = '') {
        const translit = prepareTranslit(value)

        this.where((q) => {
            q.where('text', {
                query: value,
                fuzziness: 'auto'
            })

            q.orWhere('translit', {
                query: translit,
                fuzziness: 'auto',
                boost: 0.5
            })
        })

        return this
    }
}
